export default __webpack_public_path__ + "static/media/main-slider-blood-test-results.771982bb.png";